export default __webpack_public_path__ + "src/static/images/handtinyblack.gif";